module.exports = __webpack_public_path__ + "static/advice2-3fd3a610e8955e4ce041701a66d201bc.png";